import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export class AuthenticationErrorHandler implements ErrorHandler {
  public constructor(private router: Router,private oAuthService: OAuthService,) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      this.oAuthService.logOut();
    }
  }
}
